import React from 'react'
import { Box, Typography } from '@mui/material'
import { useAlertIndicationStore } from '@/store/notification/alertIndicationStore'

/**
 * Renders alert name with "התראה מושתקת" subtitle when the alert is muted
 * and the user has enabled the indication setting.
 */
export const renderAlertWithMutedIndication = (alertName: string, row: any): React.ReactNode => {
  const isMuted = row.isMuted === true
  const showIndication = useAlertIndicationStore.getState().showMutedAlertIndication

  if (isMuted && showIndication) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', lineHeight: 1.3 }}>
        <span>{alertName}</span>
        <Typography
          component="span"
          sx={{
            fontSize: '11px',
            color: '#94A3B8',
            fontFamily: 'Rubik',
            fontWeight: 400,
          }}
        >
          התראה מושתקת
        </Typography>
      </Box>
    )
  }

  return alertName || '-'
}
